// extracted by mini-css-extract-plugin
export default {"feed":"styles-module__feed__src-labstep-web-components-OrderRequest-List-_vrkGu","body":"styles-module__body__src-labstep-web-components-OrderRequest-List-_JNJWR"};